export const TIPOLOGIE_STRUMENTO = [
  'Auto', 'Furgone', 'Camion',
  'Strumento di lavoro', 'Macchinario'
] as const

export type TipologiaStrumento = typeof TIPOLOGIE_STRUMENTO[number]

export interface Strumento {
  id: string
  tipologia: string | null
  descrizione: string
  data_acquisto: string | null
  necessaria_taratura: boolean
  note: string | null
  scadenze_count: number
  scadenze_attive_count: number
  created_at: string
}

export interface StrumentoForm {
  tipologia: string
  descrizione: string
  data_acquisto: string
  necessaria_taratura: boolean
  note: string
}

export interface Scadenza {
  id: string
  strumento_id: string
  descrizione: string
  data_scadenza: string
  giorni_preavviso: number
  risolta: boolean
  created_at: string
}

export interface ScadenzaForm {
  descrizione: string
  data_scadenza: string
  giorni_preavviso: number
  risolta: boolean
}

export interface ScadenzaInScadenza {
  id: string
  strumento_id: string
  strumento_descrizione: string
  descrizione: string
  data_scadenza: string
  giorni_preavviso: number
  giorni_rimanenti: number
}

export interface BulkDownloadAllegatoStrumento {
  id: string
  titolo: string
  filename: string
  file_size: number
  content_type: string
  created_at: string
}

export interface BulkDownloadGroupStrumento {
  strumento_id: string
  descrizione: string
  allegati: BulkDownloadAllegatoStrumento[]
}
